import { Heading2, LinkButton, Pending } from '@cluey/cluey-components';
import { minBy } from 'lodash';

import { ReactComponent as CheckIcon } from '../../../../assets/images/icon-filled-tick.svg';
import { Loader } from '../../../../components/Loader';
import useAccountPricingPlanQuery from '../../../../hooks/queries/useAccountPricingPlanQuery';
import useRetrievePricingPlansQuery from '../../../../hooks/queries/useRetrievePricingPlansQuery';
import { PATH_HUB_CHANGE_PLAN } from '../../../../util/pagePath';
import { canTransitionToCheaperPlan } from '../../../../v2/common/helpers/canTransitionToCheaperPlan';
import { calculatePlanDollarDifference } from '../../../../views/account/ChangePricingPlanPage/helper';

const CancellationDeterrent = () => {
  const { data: pricingPlans, isLoading: isLoadingPricingPlans } = useAccountPricingPlanQuery();
  const { currentPricingPlan } = pricingPlans ?? {};
  const { data: alternativePricingPlans, isLoading: isLoadingAlternativePricingPlans } = useRetrievePricingPlansQuery();
  const { allowedPlansForTransition } = alternativePricingPlans || { allowedPlansForTransition: [] };
  const cheapestPlan = minBy(allowedPlansForTransition, 'privatePriceTier.costPerSession');
  const dollarSavings = calculatePlanDollarDifference(currentPricingPlan, cheapestPlan);
  const texts = [
    "Commit to your child's learning",
    `Switch to a different plan and save up to $${dollarSavings} per session`,
    'Discover the right plan to fit your needs',
  ];
  const hideDeterrent = !canTransitionToCheaperPlan(currentPricingPlan, allowedPlansForTransition);
  return (
    <Pending loading={isLoadingPricingPlans || isLoadingAlternativePricingPlans} loader={<Loader />}>
      {hideDeterrent ? null : (
        <div className="mb-5 inline-block w-full rounded p-8" style={{ backgroundColor: '#FFF3EB' }}>
          <Heading2 className="!mb-5">Did you know? We have more affordable plans</Heading2>
          <div className="space-y-4">
            {texts.map((text) => (
              <div key={text} className="flex items-center gap-x-3">
                <CheckIcon width={16} height={16} />
                <span className="text-grey-5">{text}</span>
              </div>
            ))}
          </div>
          <LinkButton appearance="reverse" to={PATH_HUB_CHANGE_PLAN} className="mt-5">
            View all pricing plans
          </LinkButton>
        </div>
      )}
    </Pending>
  );
};

export default CancellationDeterrent;
